<div class="container">
  <div class="card">
    <div class="task-head">
      <h4>The map highlights regular collection locations. Tasking in these areas increases the collection.</h4>
    </div>

    <div style="min-width: 200px; position: relative;">
      <div id="leafletContainer" class="leaflet-container-custom"></div>

      <mat-progress-bar
        *ngIf="dataLoading"
        class="leaflet-progress"
        mode="indeterminate"
      >
      </mat-progress-bar>

      <div class="latlon-overlay">
        {{ latlonOverlay }}
      </div>

      <div class="d-flex justify-content-center" style="margin-top: 15px;">
        <button
          mat-button
          class="button-blue"
          (keydown)="onKeyPress($event, 'NO')"
          (click)="onNoClick('NO')"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
